import authModule from "../../../utilities/AuthModule";
import { IFileToUpload } from "../interfaces/IFileToUpload";
import { OneDriveOverWriteEnum } from "../components/enums/oneDriveOverWriteEnum";
import { BasePersistor } from "./BasePersistor";
import { IPersistor } from "../interfaces/IPersistor";
import { ISharepointOfficeDataDto } from "../interfaces/ISharepointOfficeDataDto";
import { FileService } from "./FileService";
import { IOneDriveOfficeDataDto } from "../interfaces/IOneDriveOfficeDataDto";
import { API } from "../config/constants";
import { SavingLocationState } from "../types";
import { FolderTypeEnum } from "../components/enums/FolderTypeEnum";
import { CheckinTypes, ListSettings } from "../components/_v2/redux/api/local/api-local-interfaces";
import { FileMetaData } from "../interfaces/props/FileMetaData";
import { apiFileSystemCallDynamicEndpoint } from "./ApiService";
import { SaveMode } from "../components/enums/SaveModeEnum";

export class OfficePersistor extends BasePersistor implements IPersistor {
  isFileSystemFileUpload: boolean
  constructor(isFileSystemFileUpload: boolean) {
    super();
    this.isFileSystemFileUpload = isFileSystemFileUpload;
  }

  saveToSharepoint = async (
    selectedFiles: IFileToUpload[],
    savingLocation: SavingLocationState,
    // folderPermissions: currentSharepointFolderState,
    autoFolderCreation: boolean,
    fileMetaData: FileMetaData[],
    accountId: string,
    informationProtectionId: string,
    outlookToken?: string,
    outlookFolderType?: FolderTypeEnum,
    autoRemoveMailItemAttachments?: boolean,
    convertEmailToPDF?: boolean,
    tenantOcrLanguage?: string,
    tenantPiiEnabled?: boolean,
    tenantReplaceFileNameWithGUID?: boolean,
    listSettings?: ListSettings,
    checkinType?: CheckinTypes,
    ensureUniqueFileName?: boolean,
    exchangeAccountEmail?: string,
    graphMailItemCategory?: string,
    saveMode?: SaveMode
  ): Promise<any> => {

    let base64Content: string;
    const officeFile = !this.isFileSystemFileUpload ? selectedFiles.find(file => !file.originalName) : undefined;

    if (officeFile) {
      base64Content = await FileService.GetFileContent();
      if (!base64Content) {
        return null;
      }
    }

    const userAuthData = await authModule.getAuthData();
    if (!userAuthData || !userAuthData.account) {
      authModule.signOut();
      return null;
    }

    let dataToSend: ISharepointOfficeDataDto = {
      sharepointInfo: {
        graphToken: userAuthData.graphToken,
        sharepointToken: userAuthData.sharePointToken,
        // informationProtectionToken: userAuthData.informationProtectionToken,
        // mailToken: userAuthData.mailboxToken && await authModule.getMailboxAccessToken(),
        siteUrl: savingLocation.webUrl,
        documentLibrary: savingLocation.documentLibrary,
        sharepointListId: savingLocation.sharePointListId,
        sharePointUniqueId: savingLocation.sharePointUniqueId,
        directory: savingLocation.directory,
        // autoFolderCreation: !folderPermissions.canView
        autoFolderCreation: autoFolderCreation,
        ensureUniqueFileName,
        checkinType: checkinType
      },
      saveMode: saveMode,
      officeFile: officeFile && { ContentBase64: base64Content, name: officeFile.name, extension: officeFile.extension, id: officeFile.id, isDuplicate: officeFile.isDuplicate === true },
      fileContents: selectedFiles.filter(file => file.originalName),
      fileMetadataList: fileMetaData.map(file => {
        return {
          fileId: file.fileId,
          metaData: this.mapFileMetadata(file)
        }
      }),
      tenantGuid: userAuthData.account.tenantId,
      accountId: accountId,
      username: userAuthData.account.username,
      sensitivityLabelId: informationProtectionId,
      tenantOcrLanguage: tenantOcrLanguage,
      tenantPiiEnabled: tenantPiiEnabled,
      tenantReplaceFileNameWithGUID: tenantReplaceFileNameWithGUID,
      listSettings,
      exchangeAccountEmail,
      graphMailItemCategory,
      teamId: savingLocation.teamId,
      channelId: savingLocation.channelId
    };

    return await apiFileSystemCallDynamicEndpoint(API.url.office.sharepoint, false, dataToSend);
  };

  saveToOneDrive = async (
    selectedFiles: IFileToUpload[],
    directory: string,
    oneDriveOverwriteOption: OneDriveOverWriteEnum,
    _outlookToken: string,
    folderName: string = "",
    accountId: string,
    autoRemoveMailItemAttachments?: boolean,
    convertEmailToPDF?: boolean,
    tenantOcrLanguage?: string,
    exchangeAccountEmail?: string,
    graphMailItemCategory?: string,
    saveMode?: SaveMode
  ) => {
    let base64Content: string;
    const officeFile = !this.isFileSystemFileUpload ? selectedFiles.find(file => !file.originalName) : undefined;
    if (officeFile) {
      base64Content = await FileService.GetFileContent();
      if (!base64Content) {
        return null;
      }
    }

    let dataToSend: IOneDriveOfficeDataDto = {
      accountId: accountId,
      graphToken: await authModule.getGraphAccessToken(),
      // mailToken: authModule.getPersistedAuthState()?.mailboxToken && await authModule.getMailboxAccessToken(),
      officeFile: officeFile && {
        id: officeFile.id,
        ContentBase64: base64Content,
        name: officeFile.name,
        extension: officeFile.extension,
        isDuplicate: officeFile.isDuplicate === true
      },
      fileContents: selectedFiles.filter(file => file.originalName),
      directory: this.getSavingDirectory(directory, folderName),
      overWriteType: oneDriveOverwriteOption,
      tenantOcrLanguage: tenantOcrLanguage,
      exchangeAccountEmail,
      graphMailItemCategory,
      saveMode
    };

    return await apiFileSystemCallDynamicEndpoint(API.url.office.oneDrive, true, dataToSend);
  };
}
